import React from 'react';
import WeeklyInputForm from './WeeklyInputForm';
import KPICards from './KPICards';
import WeeklySessionsChart from './WeeklySessionsChart';
import ClientConversionTable from './ClientConversionTable';
import ReferralSourceBar from './ReferralSourceBar';
import VersionFooter from './VersionFooter';

const ClinicianDashboard = ({ user }) => {
  return (
    <div>
      <KPICards user={user} />
      <WeeklyInputForm user={user} />
      <WeeklySessionsChart user={user} />
      <ClientConversionTable user={user} />
      <ReferralSourceBar user={user} />
      <VersionFooter />
    </div>
  );
};

export default ClinicianDashboard;
